export { default } from './ClickPropagationBarrier';
